import React from "react";
import {
  Box,
  CircularProgress
} from "@mui/material";

const Loading = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
    <Box sx={{ background: "white", borderRadius: 1, padding: "24px", width: "124px", height: 124, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress/>
    </Box>
  </Box>
)

export default Loading
